// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header {
  height: 80px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  z-index: 100;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header {
    height: 65px;
  }
}

.Header-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.Header-box1 {
  flex: 1 1;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-box1 {
    display: none;
  }
}

.Header-box2 {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-box2 {
    flex: 1 1;
  }
}

.Header-logo {
  width: 100%;
  height: 45px;
  object-fit: contain;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-logo {
    height: 33px;
  }
}

.Header-box3 {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-box3 {
    display: none;
  }
}

.Header-box4 {
  width: 20px;
  color: #818181;
}
@media screen and (min-width: 768px) {
  .Header-box4 {
    display: none;
  }
}

.Header-box4 .ant-picker-suffix {
  font-size: 18px;
  color: #818181;
}

.Header_timerBox {
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  color: gray;
}

.Header_timerBox_DatePicker .ant-picker-input input {
  color: gray !important;
  font-size: 12px !important;
  font-family: "NotoSansMalayalam-SemiBold";
}

.Header-box1 .ant-picker-suffix {
  display: none !important;
}

.Header-icon {
  margin-left: 30px;
  color: #000;
}

.Edition {
  border-bottom: 1px solid rgb(240, 240, 240);
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition {
    margin-left: -10px;
  }
}

.Edition-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  overflow: hidden;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-box {
    display: block;
    overflow-x: scroll;
    scroll-behavior: smooth;
    overflow-y: hidden;
    white-space: nowrap;
  }
}

.Edition-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.Edition-item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
  padding: 0px 20px;
  border-right: 1px solid rgb(240, 240, 240);
  height: 32px;
  text-align: center;
  border-bottom: 2px solid rgb(255, 255, 255);
  flex-shrink: 0;
}
.Edition-item:hover {
  background-color: rgba(0, 162, 255, 0.0941176471);
  border-bottom: 2px solid rgb(5, 118, 183);
  cursor: pointer;
}
.Edition-item.active {
  background-color: rgba(0, 162, 255, 0.0941176471);
  border-bottom: 2px solid rgb(5, 118, 183);
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-item {
    display: inline-block;
    vertical-align: middle;
    padding: 0px 30px;
  }
}

.Edition-txt1 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-txt1 {
    padding: 0px;
    width: 17px; /* Fixed smaller width on mobile */
  }
}
.Edition-item2 {
  display: flex;
  align-items: center;
  font-family: "NotoSansMalayalam-Bold" !important;
  font-size: 14px;
  border-right: 1px solid rgb(229, 229, 229);
  background-color: rgba(0, 162, 255, 0.0941176471);
  padding-right: 10px;
  height: 32px;
  flex-shrink: 0;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-item2 {
    display: inline-block;
    vertical-align: middle;
    width: 150px;
    padding-right: 8px;
    padding-left: 8px;
    font-size: 12px;
    height: auto;
  }
}

.Edition-desktop-items {
  display: inline-block;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-desktop-items {
    display: none;
  }
}

.Edition-desktop-tabs {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-desktop-tabs {
    display: none;
  }
}

.Edition-tabs .ant-tabs-nav {
  margin-bottom: 0;
}
.Edition-tabs .ant-tabs-nav::before {
  border-bottom: none;
}
.Edition-tabs .ant-tabs-tab {
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
  padding: 0 30px;
  margin: 0;
  height: 32px;
  line-height: 32px;
  border-right: 1px solid rgb(240, 240, 240);
  transition: all 0.2s ease;
}
.Edition-tabs .ant-tabs-tab:hover {
  background-color: rgba(0, 162, 255, 0.0941176471);
  color: rgb(5, 118, 183);
}
.Edition-tabs .ant-tabs-tab-active {
  background-color: rgba(0, 162, 255, 0.0941176471);
}
.Edition-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: rgb(5, 118, 183);
}
.Edition-tabs .ant-tabs-ink-bar {
  background-color: rgb(5, 118, 183);
  height: 2px;
}
.Edition-tabs .ant-tabs-nav-operations {
  display: flex !important;
  align-items: center;
}
.Edition-tabs .ant-tabs-nav-more {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  color: #333;
  border-left: 1px solid rgb(240, 240, 240);
  background: #fff;
}
.Edition-tabs .ant-tabs-nav-more:hover {
  color: rgb(5, 118, 183);
}
.Edition-tabs .ant-tabs-tab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-tabs-dropdown-menu {
  font-family: "NotoSansMalayalam-SemiBold";
  max-height: 400px;
  overflow-y: auto;
}
.ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item {
  padding: 10px 16px;
  font-size: 14px;
}
.ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item:hover {
  background-color: rgba(0, 162, 255, 0.0941176471);
}
.ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item-active {
  background-color: rgba(0, 162, 255, 0.0941176471);
  color: rgb(5, 118, 183);
}

.Edition-mobile-button {
  display: none;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .Edition-mobile-button {
    display: inline-block;
    vertical-align: middle;
    font-family: "NotoSansMalayalam-SemiBold";
    font-size: 14px;
    padding: 0;
    border-right: 1px solid rgb(240, 240, 240);
    height: 33px;
    text-align: center;
    border-bottom: 2px solid rgb(255, 255, 255);
    background-color: rgba(0, 162, 255, 0.0941176471);
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .Edition-mobile-button:hover {
    background-color: rgba(0, 162, 255, 0.1450980392);
  }
}
/* New styles for the button content and icon */
.Edition-mobile-btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 12px;
  gap: 6px;
}

.Edition-mobile-btn-text {
  font-size: 13px;
  font-weight: 600;
  color: #333; /* Black text color */
  white-space: nowrap;
  font-family: "NotoSansMalayalam-SemiBold";
}

.Edition-modal .ant-modal-content {
  border-radius: 12px;
}

.Edition-modal .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 20px;
}

.Edition-modal .ant-modal-title {
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 16px;
}

.Edition-modal-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 0;
}

.Edition-modal-item {
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
}

.Edition-modal-item:hover {
  background-color: #f5f5f5;
}

.Edition-modal-item.active {
  background-color: rgba(0, 162, 255, 0.0941176471);
  color: rgb(5, 118, 183);
  font-weight: bold;
}

.Edition-modal-item:last-child {
  border-bottom: none;
}

.Edition-modal-txt {
  text-align: left;
}

.Edition-mobile-btn-icon {
  width: 14px;
  height: 14px;
  color: #666; /* Slightly lighter for the icon */
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

/* Avatar Styles */
.Header-user-avatar {
  position: relative;
  margin-left: 20px;
}

.Header-mobile-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.Header-avatar {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Header-avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #0576b7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  line-height: 1;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.Header-avatar-circle:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-avatar-circle {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
}

.Header-user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #e5e5e5;
  min-width: 220px;
  z-index: 1000;
  overflow: hidden;
}
.Header-user-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 14px;
  width: 12px;
  height: 12px;
  background: white;
  border: 1px solid #e5e5e5;
  border-bottom: none;
  border-right: none;
  transform: rotate(45deg);
}

.Header-mobile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: -10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #e5e5e5;
  min-width: 200px;
  z-index: 1000;
  overflow: hidden;
}
.Header-mobile-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: white;
  border: 1px solid #e5e5e5;
  border-bottom: none;
  border-right: none;
  transform: rotate(45deg);
}

.Header-user-info {
  padding: 16px;
  background: #f8f9fa;
}

.Header-user-name {
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
  line-height: 1.2;
}

.Header-user-email {
  font-family: "NotoSansMalayalam-Regular";
  font-size: 12px;
  color: #666;
  line-height: 1.2;
  word-break: break-all;
}

.Header-user-divider {
  height: 1px;
  background: #e5e5e5;
}

.Header-user-actions {
  padding: 8px;
}

.Header-logout-btn {
  width: 100%;
  background: none;
  border: none;
  padding: 10px 12px;
  font-family: "NotoSansMalayalam-Regular";
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}
.Header-logout-btn:hover {
  background: #f5f5f5;
  color: #333;
}
.Header-logout-btn:active {
  transform: scale(0.98);
}

/* Desktop specific styles */
@media screen and (min-width: 769px) {
  .Header-mobile-avatar {
    display: none;
  }
}
/* Mobile specific styles */
@media screen and (min-width: 320px) and (max-width: 768px) {
  .Header-user-avatar {
    display: none;
  }
  .Header-box4 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/header/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAAE;EAVF;IAWI,YAAA;EAGF;AACF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAGF;;AAAA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AAGF;AAFE;EAJF;IAKI,aAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAKF;AAJE;EALF;IAMI,SAAA;EAOF;AACF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAOF;AANE;EAJF;IAKI,YAAA;EASF;AACF;;AANA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AASF;AARE;EANF;IAOI,aAAA;EAWF;AACF;;AARA;EACE,WAAA;EACA,cAAA;AAWF;AAVE;EAHF;IAII,aAAA;EAaF;AACF;;AAVA;EACE,eAAA;EACA,cAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAaF;;AAVA;EACE,sBAAA;EACA,0BAAA;EACA,yCAAA;AAaF;;AAVA;EACE,wBAAA;AAaF;;AAVA;EACE,iBAAA;EACA,WAAA;AAaF;;AAPA;EACE,2CAAA;AAUF;AATE;EAFF;IAGI,kBAAA;EAYF;AACF;;AATA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAYF;AAVE;EANF;IAOI,cAAA;IACA,kBAAA;IACA,uBAAA;IACA,kBAAA;IACA,mBAAA;EAaF;AACF;;AAVA;EACE,UAAA;EACA,WAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,cAAA;AAaF;AAZE;EACE,iDAAA;EACA,yCAAA;EACA,eAAA;AAcJ;AAZE;EACE,iDAAA;EACA,yCAAA;EACA,eAAA;AAcJ;AAXE;EAvBF;IAwBI,qBAAA;IACA,sBAAA;IACA,iBAAA;EAcF;AACF;;AAXA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAcF;;AAZA;EACE;IACE,YAAA;IACA,WAAA,EAAA,kCAAA;EAeF;AACF;AAZA;EACE,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,eAAA;EACA,0CAAA;EACA,iDAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAcF;AAZE;EAXF;IAYI,qBAAA;IACA,sBAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,eAAA;IACA,YAAA;EAeF;AACF;;AAXA;EACE,qBAAA;AAcF;AAZE;EAHF;IAII,aAAA;EAeF;AACF;;AAXA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AAcF;AAZE;EALF;IAMI,aAAA;EAeF;AACF;;AAXE;EACE,gBAAA;AAcJ;AAZI;EACE,mBAAA;AAcN;AAVE;EACE,yCAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;AAYJ;AAVI;EACE,iDAAA;EACA,uBAAA;AAYN;AARE;EACE,iDAAA;AAUJ;AARI;EACE,uBAAA;AAUN;AANE;EACE,kCAAA;EACA,WAAA;AAQJ;AAJE;EACE,wBAAA;EACA,mBAAA;AAMJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,yCAAA;EACA,gBAAA;AAKJ;AAHI;EACE,uBAAA;AAKN;AADE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;;AAEA;EACE,yCAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;AACJ;AACI;EACE,iDAAA;AACN;AAEI;EACE,iDAAA;EACA,uBAAA;AAAN;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE;IACE,qBAAA;IACA,sBAAA;IACA,yCAAA;IACA,eAAA;IACA,UAAA;IACA,0CAAA;IACA,YAAA;IACA,kBAAA;IACA,2CAAA;IACA,iDAAA;IACA,eAAA;IACA,sCAAA;EAHF;EAMA;IACE,iDAAA;EAJF;AACF;AAMA,+CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;AAJF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,WAAA,EAAA,qBAAA;EACA,mBAAA;EACA,yCAAA;AAHF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,eAAA;AAFF;;AAKA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,iCAAA;EACA,yCAAA;EACA,eAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,iDAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,WAAA,EAAA,kCAAA;EACA,+BAAA;EACA,cAAA;AADF;;AAIA,kBAAA;AACA;EACE,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qFAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAFF;AAIE;EACE,sBAAA;EACA,0CAAA;AAFJ;AAKE;EAvBF;IAwBI,WAAA;IACA,YAAA;IACA,eAAA;EAFF;AACF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAHF;AAKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;AAJF;;AAOA;EACE,yCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,wCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,WAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAJF;AAME;EACE,mBAAA;EACA,WAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;;AASA,4BAAA;AACA;EACE;IACE,aAAA;EANF;AACF;AASA,2BAAA;AACA;EACE;IACE,aAAA;EAPF;EAUA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EARF;AACF","sourcesContent":[".Header {\n  height: 80px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  z-index: 100;\n  width: 100%;\n  top: 0;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    height: 65px;\n  }\n}\n\n.Header-box {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.Header-box1 {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.Header-box2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    flex: 1;\n  }\n}\n\n.Header-logo {\n  width: 100%;\n  height: 45px;\n  object-fit: contain;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    height: 33px;\n  }\n}\n\n.Header-box3 {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.Header-box4 {\n  width: 20px;\n  color: #818181;\n  @media screen and (min-width: 768px) {\n    display: none;\n  }\n}\n\n.Header-box4 .ant-picker-suffix {\n  font-size: 18px;\n  color: #818181;\n}\n\n.Header_timerBox {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  align-items: center;\n  color: gray;\n}\n\n.Header_timerBox_DatePicker .ant-picker-input input {\n  color: gray !important;\n  font-size: 12px !important;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n}\n\n.Header-box1 .ant-picker-suffix {\n  display: none !important;\n}\n\n.Header-icon {\n  margin-left: 30px;\n  color: #000;\n}\n\n.Edition-box1 {\n}\n\n.Edition {\n  border-bottom: 1px solid rgb(240, 240, 240);\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    margin-left: -10px;\n  }\n}\n\n.Edition-box {\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n  overflow: hidden;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: block;\n    overflow-x: scroll;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n    white-space: nowrap;\n  }\n}\n\n.Edition-box::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n.Edition-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n  padding: 0px 20px;\n  border-right: 1px solid rgb(240, 240, 240);\n  height: 32px;\n  text-align: center;\n  border-bottom: 2px solid rgb(255, 255, 255);\n  flex-shrink: 0;\n  &:hover {\n    background-color: #00a2ff18;\n    border-bottom: 2px solid rgb(5, 118, 183);\n    cursor: pointer;\n  }\n  &.active {\n    background-color: #00a2ff18;\n    border-bottom: 2px solid rgb(5, 118, 183);\n    cursor: pointer;\n  }\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: inline-block;\n    vertical-align: middle;\n    padding: 0px 30px;\n  }\n}\n\n.Edition-txt1 {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (min-width: 320px) and (max-width: 768px) {\n  .Edition-txt1 {\n    padding: 0px;\n    width: 17px; /* Fixed smaller width on mobile */\n  }\n}\n\n.Edition-item2 {\n  display: flex;\n  align-items: center;\n  font-family: \"NotoSansMalayalam-Bold\" !important;\n  font-size: 14px;\n  border-right: 1px solid rgb(229, 229, 229);\n  background-color: #00a2ff18;\n  padding-right: 10px;\n  height: 32px;\n  flex-shrink: 0;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: inline-block;\n    vertical-align: middle;\n    width: 150px;\n    padding-right: 8px;\n    padding-left: 8px;\n    font-size: 12px;\n    height: auto;\n  }\n}\n\n// Desktop items (used in detailScreen)\n.Edition-desktop-items {\n  display: inline-block;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n// Desktop Tabs (used in homescreen and detailScreen)\n.Edition-desktop-tabs {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.Edition-tabs {\n  .ant-tabs-nav {\n    margin-bottom: 0;\n\n    &::before {\n      border-bottom: none;\n    }\n  }\n\n  .ant-tabs-tab {\n    font-family: \"NotoSansMalayalam-SemiBold\";\n    font-size: 14px;\n    padding: 0 30px;\n    margin: 0;\n    height: 32px;\n    line-height: 32px;\n    border-right: 1px solid rgb(240, 240, 240);\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #00a2ff18;\n      color: rgb(5, 118, 183);\n    }\n  }\n\n  .ant-tabs-tab-active {\n    background-color: #00a2ff18;\n\n    .ant-tabs-tab-btn {\n      color: rgb(5, 118, 183);\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: rgb(5, 118, 183);\n    height: 2px;\n  }\n\n  // Dropdown arrow styling\n  .ant-tabs-nav-operations {\n    display: flex !important;\n    align-items: center;\n  }\n\n  .ant-tabs-nav-more {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n    padding: 0 12px;\n    color: #333;\n    border-left: 1px solid rgb(240, 240, 240);\n    background: #fff;\n\n    &:hover {\n      color: rgb(5, 118, 183);\n    }\n  }\n\n  .ant-tabs-tab-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n// Dropdown menu styling (for overflow tabs)\n.ant-tabs-dropdown-menu {\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  max-height: 400px;\n  overflow-y: auto;\n\n  .ant-tabs-dropdown-menu-item {\n    padding: 10px 16px;\n    font-size: 14px;\n\n    &:hover {\n      background-color: #00a2ff18;\n    }\n\n    &-active {\n      background-color: #00a2ff18;\n      color: rgb(5, 118, 183);\n    }\n  }\n}\n\n// Mobile button\n.Edition-mobile-button {\n  display: none;\n}\n\n@media screen and (min-width: 320px) and (max-width: 768px) {\n  .Edition-mobile-button {\n    display: inline-block;\n    vertical-align: middle;\n    font-family: \"NotoSansMalayalam-SemiBold\";\n    font-size: 14px;\n    padding: 0;\n    border-right: 1px solid rgb(240, 240, 240);\n    height: 33px;\n    text-align: center;\n    border-bottom: 2px solid rgb(255, 255, 255);\n    background-color: #00a2ff18;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n  .Edition-mobile-button:hover {\n    background-color: #00a2ff25;\n  }\n}\n/* New styles for the button content and icon */\n.Edition-mobile-btn-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 12px;\n  gap: 6px;\n}\n.Edition-mobile-btn-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333; /* Black text color */\n  white-space: nowrap;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n}\n.Edition-modal .ant-modal-content {\n  border-radius: 12px;\n}\n\n.Edition-modal .ant-modal-header {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 16px 20px;\n}\n\n.Edition-modal .ant-modal-title {\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 16px;\n}\n\n.Edition-modal-content {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 10px 0;\n}\n\n.Edition-modal-item {\n  padding: 12px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n}\n\n.Edition-modal-item:hover {\n  background-color: #f5f5f5;\n}\n\n.Edition-modal-item.active {\n  background-color: #00a2ff18;\n  color: rgb(5, 118, 183);\n  font-weight: bold;\n}\n\n.Edition-modal-item:last-child {\n  border-bottom: none;\n}\n\n.Edition-modal-txt {\n  text-align: left;\n}\n.Edition-mobile-btn-icon {\n  width: 14px;\n  height: 14px;\n  color: #666; /* Slightly lighter for the icon */\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n/* Avatar Styles */\n.Header-user-avatar {\n  position: relative;\n  margin-left: 20px;\n}\n\n.Header-mobile-avatar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.Header-avatar {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Header-avatar-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  background-color: #0576b7;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n  line-height: 1;\n  text-align: center;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  &:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n}\n\n.Header-user-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border: 1px solid #e5e5e5;\n  min-width: 220px;\n  z-index: 1000;\n  overflow: hidden;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: -6px;\n    right: 14px;\n    width: 12px;\n    height: 12px;\n    background: white;\n    border: 1px solid #e5e5e5;\n    border-bottom: none;\n    border-right: none;\n    transform: rotate(45deg);\n  }\n}\n\n.Header-mobile-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: -10px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border: 1px solid #e5e5e5;\n  min-width: 200px;\n  z-index: 1000;\n  overflow: hidden;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: -6px;\n    right: 20px;\n    width: 12px;\n    height: 12px;\n    background: white;\n    border: 1px solid #e5e5e5;\n    border-bottom: none;\n    border-right: none;\n    transform: rotate(45deg);\n  }\n}\n\n.Header-user-info {\n  padding: 16px;\n  background: #f8f9fa;\n}\n\n.Header-user-name {\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 4px;\n  line-height: 1.2;\n}\n\n.Header-user-email {\n  font-family: \"NotoSansMalayalam-Regular\";\n  font-size: 12px;\n  color: #666;\n  line-height: 1.2;\n  word-break: break-all;\n}\n\n.Header-user-divider {\n  height: 1px;\n  background: #e5e5e5;\n}\n\n.Header-user-actions {\n  padding: 8px;\n}\n\n.Header-logout-btn {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 10px 12px;\n  font-family: \"NotoSansMalayalam-Regular\";\n  font-size: 13px;\n  color: #666;\n  cursor: pointer;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f5f5f5;\n    color: #333;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n}\n\n/* Desktop specific styles */\n@media screen and (min-width: 769px) {\n  .Header-mobile-avatar {\n    display: none;\n  }\n}\n\n/* Mobile specific styles */\n@media screen and (min-width: 320px) and (max-width: 768px) {\n  .Header-user-avatar {\n    display: none;\n  }\n\n  .Header-box4 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
